

import {defineComponent} from "vue";
import {definition} from './dropdown';
export default defineComponent(definition())

